module.exports = __webpack_public_path__ + "img/woman-avatar.987736b1.png";